import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../../store/popupSlice"
import { Helmet } from "react-helmet-async";
import LyftTeamlogo from "../../cloneApps/LyftClone/LyftTeamlogo";
import Breadcrumb from "../../../component/Breadcrumb";

export default function Landing2Banner({breadcrumbData}) {
  const dispatch = useDispatch();
  return (
    <>
      <Helmet>
        <link rel="preload" href="/assets/home/land2-banner.webp" as="image" type="image/webp" />
      </Helmet>
      <section className="land-2-banner header-gap">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <h1 className="heading center-heading">Advanced Taxi Dispatch Software</h1>
            </div>
            <div className="col-lg-8 text-center">
              <div className="land2-banner-head">
                <p className="sub-heading">Empower your taxi business software with a fully customizable solution. Get a taxi driver app, taxi rider app, taxi software dispatch panel, and taxi admin dashboard - all seamlessly integrated to streamline operations.</p>
                <span>21 Days Free Trial | No Credit Card Required</span>
                {breadcrumbData && <Breadcrumb breadcrumbData={breadcrumbData}/>}
                <div className="land-two-btns">
                  <Link onClick={() => dispatch(openPopup())} className="default-btn">book free demo</Link>
                  <Link style={{ marginLeft: "15px" }} to={`/features/taxi-dispatch-software`} className="default-btn "> Explore Features </Link>
                </div>
                <img src="/assets/home/land2-banner.webp" alt="banner" className="img-responsive" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="land2-banner-logo">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <span>Trusted by 1,000+ Companies Worldwide</span>
            </div>

            {/* <div className="col-lg-10">
              <div className="row">
                <div className="col-lg-2 col-4 col-md-2">
                  <img src="/assets/home/land2-bann-logo-1.webp" alt="logo" className="img-responsive" />
                </div>
                <div className="col-lg-2 col-4 col-md-2">
                  <img src="/assets/home/land2-bann-logo-2.webp" alt="logo" className="img-responsive" />
                </div>
                <div className="col-lg-2 col-4 col-md-2">
                  <img src="/assets/home/land2-bann-logo-3.webp" alt="logo" className="img-responsive" />
                </div>
                <div className="col-lg-2 col-4 col-md-2">
                  <img src="/assets/home/land2-bann-logo-4.webp" alt="logo" className="img-responsive" />
                </div>
                <div className="col-lg-2 col-4 col-md-2">
                  <img src="/assets/home/land2-bann-logo-5.webp" alt="logo" className="img-responsive" />
                </div>
                <div className="col-lg-2 col-4 col-md-2">
                  <img src="/assets/home/land2-bann-logo-6.webp" alt="logo" className="img-responsive" />
                </div>
              </div>
            </div> */}
            <LyftTeamlogo/>
          </div>
        </div>
      </section>
    </>
  )
}
